<template>
    <div class="checkout-area ptb-100">
        <div class="container">
            <div class="user-actions">
                <span>Returning customer? 
                    <router-link to="/profile-authentication">Click here to login</router-link>
                </span>
            </div>
            <form @submit.prevent>
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="billing-details">
                            <h3><span>Billing details</span></h3>
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label>First name <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label>Last name <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Company name (optional)</label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Country / Region <span class="required">*</span></label>
                                        <input type="text" class="form-control" placeholder="Country / Region">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Street address <span class="required">*</span></label>
                                        <input type="text" class="form-control" placeholder="House number and street name">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Apartment, suite, unit, etc. (optional)">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Town / City <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>County (optional)</label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Postcode <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Phone <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Email address <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-check">
                                        <input type="checkbox" class="form-check-input" id="checkme">
                                        <label class="form-check-label" for="checkme">Save this information for next time</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="billing-details">
                            <h3><span>Ship to a different address?</span></h3>
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label>First name <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <div class="form-group">
                                        <label>Last name <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Company name (optional)</label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Country / Region <span class="required">*</span></label>
                                        <input type="text" class="form-control" placeholder="Country / Region">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Street address <span class="required">*</span></label>
                                        <input type="text" class="form-control" placeholder="House number and street name">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <input type="text" class="form-control" placeholder="Apartment, suite, unit, etc. (optional)">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Town / City <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>County (optional)</label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Postcode <span class="required">*</span></label>
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label>Order notes (optional)</label>
                                        <textarea class="form-control" cols="30" rows="6" placeholder="Notes about your order, e.g. special notes for delivery."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="order-details">
                            <h3>Your order</h3>
                            <div class="order-table table-responsive">
                                <table class="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td class="product-name"><router-link to="/products-details">Black Men's T-Shirt</router-link></td>
                                            <td class="product-total">
                                                <span class="subtotal-amount">$250.00</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="product-name"><router-link to="/products-details">Floating Paper Bag</router-link></td>
                                            <td class="product-total">
                                                <span class="subtotal-amount">$200.00</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="product-name"><router-link to="/products-details">Sports Cap Black</router-link></td>
                                            <td class="product-total">
                                                <span class="subtotal-amount">$200.00</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="product-name"><router-link to="/products-details">Covid Smart Mask</router-link></td>
                                            <td class="product-total">
                                                <span class="subtotal-amount">$150.00</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-subtotal"><span>Cart Subtotal</span></td>
                                            <td class="order-subtotal-price">
                                                <span class="order-subtotal-amount">$1683.50</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-shipping"><span>Shipping</span></td>
                                            <td class="shipping-price">
                                                <span>$30.00</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="total-price"><span>Order Total</span></td>
                                            <td class="product-subtotal">
                                                <span class="subtotal-amount">$750.00</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="payment-box">
                                <div class="payment-method">
                                    <p>
                                        <input type="radio" id="direct-bank-transfer" name="radio-group" checked>
                                        <label for="direct-bank-transfer">Direct bank transfer</label>
                                        Make your payment directly into our bank account. Please use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account.
                                    </p>
                                    <p>
                                        <input type="radio" id="check-payments" name="radio-group">
                                        <label for="check-payments">Check payments</label>
                                        Please send a check to Store Name, Store Street, Store Town, Store State / County, Store Postcode.
                                    </p>
                                    <p>
                                        <input type="radio" id="paypal" name="radio-group">
                                        <label for="paypal">PayPal</label>
                                        <img src="../../assets/images/paypal.png" alt="paypal">
                                        Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our <router-link to="/privacy-policy">privacy policy</router-link>.
                                    </p>
                                    <p>
                                        <input type="radio" id="cash-on-delivery" name="radio-group">
                                        <label for="cash-on-delivery">Cash on delivery</label>
                                        Pay with cash upon delivery.
                                    </p>
                                </div>
                                <button type="submit" class="btn-style-one red-light-color">Place Order <i class="ph-caret-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Checkout'
}
</script>